import type { TripAccommodationStay } from '~/services/engine-ts';
import type { TripSection } from '~/stores/tpv2/journeyStore';
import type { StayTransformed } from '~/types/JourneyItem.types';
import type { ItineraryCardTrainTimesProps } from './ItineraryCard.types';

export type AccommodationCardVariant = 'sleeper' | 'stay-collapsed' | 'stay-expanded';

export type AccommodationCardSleeperDetails = {
  title: string;
  subheading: string;
  trainTimes: ItineraryCardTrainTimesProps;
  cabinLabel: string;
  cabinValue: string;
  bodyText: string;
};

export type AccommodationCardProps = StayTransformed & {
  section: TripSection;
  tripId: string;
  accommodationStay?: TripAccommodationStay;
  accommodationVariant?: AccommodationCardVariant;
  sleeperDetails?: AccommodationCardSleeperDetails;
};

export const CHECK_IN_ICON_SRC = '/static/images/itinerary-card-preview/check-in.png';
export const CHECK_OUT_ICON_SRC = '/static/images/itinerary-card-preview/check-out.png';

export type AccommodationCheckInOutDetails = {
  variant: 'times' | 'dates';
  checkInNoEarlierThan: string | null;
  checkInValue: string | null;
  checkOutValue: string | null;
};
